import React from 'react';
import logoImage from '../assets/logo.png';

const translations = {
  de: {
    copyright: '© 2025 Rink Hockey Scoreboard. Alle Rechte vorbehalten.',
    privacy: 'Datenschutz',
    imprint: 'Impressum',
    madeIn: 'Rink Hockey Scoreboard, made in Uttigen.',
    slogan: 'Your Game, Your Scoreboard',
    disclaimer: 'Diese Software wird so zur Verfügung gestellt, wie sie ist, und ist für die Nutzung auf eigene Gefahr bestimmt. Es wird kein Support geleistet. Die Ersteller dieser Software sind nicht verantwortlich für etwaige Probleme, Schäden oder Haftungen, die durch deren Nutzung entstehen können. Durch die Nutzung dieser Software stimmen Sie zu, die volle Verantwortung für deren Implementierung und alle Ergebnisse, die durch deren Nutzung entstehen, zu übernehmen.',
    analytics: 'Diese Website verwendet Google Analytics für anonyme Nutzungsstatistiken nur. IP-Adressen sind anonymisiert.',
  },
  en: {
    copyright: ' 2025 Rink Hockey Scoreboard. All rights reserved.',
    privacy: 'Privacy Policy',
    imprint: 'Imprint',
    madeIn: 'Rink Hockey Scoreboard, made in Uttigen.',
    slogan: 'Your Game, Your Scoreboard',
    disclaimer: 'This software is provided as it is and is intended for use at your own risk. No support is provided. The creators of this software are not responsible for any issues, damages, or liabilities that may arise from its use. By using this software, you agree to take full responsibility for its implementation and any outcomes resulting from its use.',
    analytics: 'This website uses Google Analytics for anonymous usage statistics only. IP addresses are anonymized.',
  }
};

export default function FooterSection({ lang = 'de' }) {
  const t = translations[lang];
  return (
    <div className="flex z-0 justify-between items-start px-8 py-16 w-full bg-stone-900 max-md:px-5 max-md:max-w-full">
      <div className="flex flex-wrap flex-1 shrink gap-14 justify-between items-start w-full basis-0 max-w-[1200px] min-w-[240px] max-md:max-w-full">
        <div className="flex flex-col flex-1 shrink basis-0 min-w-[248px] text-stone-100">
          <div className="flex gap-2 justify-center items-center self-start text-sm leading-relaxed">
            <img
              loading="lazy"
              src={logoImage}
              alt="Rink Hockey Scoreboard Logo"
              className="object-contain shrink-0 self-stretch my-auto w-8 aspect-square"
            />
            <div className="self-stretch my-auto">{t.madeIn}</div>
          </div>
          <div className="mt-6 text-lg">{t.slogan}</div>
        </div>
        <div className="flex-1 shrink gap-2.5 self-stretch text-sm leading-6 text-white min-w-[240px] w-[781px] max-md:max-w-full">
          {t.disclaimer}
          <div className="mt-4 text-xs text-stone-400">
            {t.analytics}
          </div>        
          <div className="text-xs text-stone-500 mt-6">{t.copyright}</div>
        </div>
      </div>
      
    </div>
  );
}